import { render, staticRenderFns } from "./MediaInfoForm.vue?vue&type=template&id=0845cd26&"
import script from "./MediaInfoForm.vue?vue&type=script&lang=js&"
export * from "./MediaInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports